import type { ParagraphPluginElement } from '../plugins/paragraph/types';

import { Node } from '../core';

export const slateContentToString = <T extends Node | ParagraphPluginElement>(
  nodes: ReadonlyArray<T>
): string => {
  return (nodes as ReadonlyArray<Node>).map((n) => Node.string(n)).join('\n');
};
